const scrollMixin = {
  methods: {
    toggleBodyScrolling(value) {
      if (value) {
        this.enableBodyScrolling();
      } else {
        this.disableBodyScrolling();
      }
    },
    disableBodyScrolling() {
      document.documentElement.style.overflowY = 'hidden';
    },
    enableBodyScrolling() {
      document.documentElement.style.overflowY = '';
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
  },
};

export default scrollMixin;
